import React from "react";

export const CanvasCIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none" viewBox="0 0 22 22">
      <path
        fill="#1E1E1E"
        d="M11.603 16.644q-1.172 0-2.046-.384a4.2 4.2 0 0 1-1.435-1.07 4.4 4.4 0 0 1-.857-1.504 5.6 5.6 0 0 1-.28-1.755v-.318q0-.936.296-1.788.297-.87.874-1.538A4.06 4.06 0 0 1 9.59 7.234q.874-.384 1.996-.384 1.221 0 2.16.484a3.8 3.8 0 0 1 1.502 1.32q.56.853.626 1.956h-2.59a1.65 1.65 0 0 0-.494-1.036q-.412-.435-1.204-.435-.66 0-1.105.335-.429.334-.643.919t-.215 1.387q0 .735.198 1.338.198.585.627.919.446.317 1.154.317.529 0 .891-.183.379-.2.594-.535.23-.351.28-.803h2.573q-.05 1.137-.627 2.006a4 4 0 0 1-1.533 1.337q-.957.468-2.177.468"
      ></path>
      <path
        stroke="#1E1E1E"
        strokeWidth="1.122"
        d="M4.892 3.324h12.979M19.356 5.489v12.202M4.892 19.511h12.979M3.363 5.489v12.202"
      ></path>
      <rect width="3.642" height="3.642" x="1.321" y="1.481" stroke="#1E1E1E" strokeWidth="1.122" rx="0.785"></rect>
      <rect width="3.642" height="3.642" x="1.321" y="17.717" stroke="#1E1E1E" strokeWidth="1.122" rx="0.785"></rect>
      <rect width="3.642" height="3.642" x="17.557" y="1.481" stroke="#1E1E1E" strokeWidth="1.122" rx="0.785"></rect>
      <rect width="3.642" height="3.642" x="17.557" y="17.717" stroke="#1E1E1E" strokeWidth="1.122" rx="0.785"></rect>
    </svg>
  );
};
